import { useHistory } from 'react-router';
import styles from "./CustomBarShape.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
const radius = 4;

// eslint-disable-next-line @typescript-eslint/no-explicit-any

/** Renders a custom bar shape with optional radius. Used in recharts "Bar" component. */
export default function CustomBarShape(props) {
  const {
    fill,
    height,
    width,
    type,
    x,
    y,
    payload,
    testId,
    getLinkUrl,
    linkTarget,
    hasRadius,
    getHasRadius,
    onFocus,
    onBlur,
    getTestId
  } = props;
  const history = useHistory();
  const linkUrl = getLinkUrl === null || getLinkUrl === void 0 ? void 0 : getLinkUrl(payload);
  const showLink = height > 0 && !!linkUrl;
  const actualTestId = getTestId ? getTestId(payload) : testId && "".concat(testId, "-bar-").concat(type);
  const bar = /*#__PURE__*/_jsx("path", {
    className: styles.root,
    "data-testid": !showLink ? actualTestId : undefined,
    fill: fill,
    width: width,
    height: height,
    type: type,
    x: x,
    y: y,
    d: height && (hasRadius || getHasRadius !== null && getHasRadius !== void 0 && getHasRadius(payload)) ? "M".concat(x, ",").concat(y + radius, "A ").concat(radius, ",").concat(radius, ",0,0,1,").concat(x + radius, ",").concat(y, "L ").concat(x + width - radius, ",").concat(y, "A ").concat(radius, ",").concat(radius, ",0,0,1, ").concat(x + width, ",").concat(y + radius, "L ").concat(x + width, ",").concat(y + height, "L ").concat(x, ",").concat(y + height, "Z") : "M ".concat(x, ",").concat(y, " h ").concat(width, " v ").concat(height, " h ").concat(-width, " Z")
  });
  return height > 0 && linkUrl ? /*#__PURE__*/_jsx("a", {
    "data-testid": showLink ? actualTestId : undefined,
    onClick: () => history.push(linkUrl),
    style: {
      cursor: 'pointer'
    },
    target: linkTarget,
    onFocus: onFocus,
    onBlur: onBlur,
    children: bar
  }) : bar;
}